import React from 'react';
import styled from 'styled-components';
import CourseCardLink from './CoursesListing/courseCardLink';
import {
  WayToViewConsumer,
  WayToViewProvider,
} from '../contexts/wayToViewList';
import SelectViewCourseList from './selectViewCourseList';
import Media from '../components/styledCompoBreakpoint';

const Title = styled.h2`
  margin-bottom: 1.5rem;
  font-size: 1.313rem;
  font-weight: 700;
  letter-spacing: -1px;
  color: #3d3d3d;
`;

const AllCardListWrapper = styled.div`
  .list-view {
    
    article {
      width: 100%;
      .card {
        flex-direction: row;
        .card-img {
          width: 30%;
          padding: 1rem;
        }
        .card-body {
          width: 55%;
          padding-top: 1.2rem;
          ${Media.sm`
            width: 50%;
          `}

          .card-title {
            font-size: 1.125rem;
          }
          
          ${Media.lg`
            .card-title {
              font-size: 1.125rem;
            }
          `}

          ${Media.md`
            .card-title {
              font-size: 1rem;
            }
          `}
        }

        .only-show-list-view {
          width: 15%;
          //min-width: 110px;
          .price {
              font-size: 1.125rem;
            }
          button {
            //min-width: 100px;
            font-size: 1rem;
          }
          ${Media.xl`
            .price {
              font-size: 1rem;
            }
            .btn {
              padding: 0.175rem 0.45rem;
            }
          `}
          ${Media.lg`
            .price {
              font-size: 0.825rem;
            }
            .btn {
              padding: 0.075rem 0.15rem;
            }
          `}
          ${Media.md`
            padding-left: 0;
            margin-right: 0;
            .btn {
              padding: 0.075rem 0.15rem;
              font-size: 0.813rem;
            }
          `}
          ${Media.sm`
            width: 20%;
          `}
        }
      }
    }
  }
`;

const CourseCardWrapper = ({cateName, midCateName}) => {
  return (
    <WayToViewProvider>
      <div className="d-flex align-items-center">
        <Title className="me-auto">{cateName} 과정 {midCateName ? `- ${midCateName}` : `- 전체`}</Title>
        <SelectViewCourseList />
      </div>
      <AllCardListWrapper>
        <WayToViewConsumer>
          {value => (
            <div className={`${value.state.viewList} row`}>
              <CourseCardLink cateName={cateName} midCateName={midCateName} />
            </div>
          )}
        </WayToViewConsumer>
      </AllCardListWrapper>
    </WayToViewProvider>
  );
};

export default CourseCardWrapper;
